module.exports = __webpack_public_path__ + "img/logo-nikon@2x.541ac07b.png";